export var KeyCodes = {
  fo: 32,
  oo: 9,
  co: 13,
  Ci: 27
};